<h3 class="title configurator-title">{{ 'fence.materials.title' | translate }}</h3>

<!-- Poses -->
<ng-casto-materials-installations></ng-casto-materials-installations>

<!-- Lames -->
<ng-casto-materials-boards></ng-casto-materials-boards>

<!-- Poteaux -->
<ng-casto-materials-posts></ng-casto-materials-posts>

<!-- Lames décoratives -->
<ng-casto-materials-decorative-boards></ng-casto-materials-decorative-boards>

<!-- Décors -->
<ng-casto-materials-decors></ng-casto-materials-decors>

<!-- Panneaux -->
<ng-casto-materials-panels></ng-casto-materials-panels>

<!-- Portillons -->
<ng-casto-materials-doors></ng-casto-materials-doors>
